<template>
  <v-card id="acceptance-weighings" class="pa-4 mb-4">
    <div class="d-flex align-center mb-3">
      <div class="text-subtitle-1 font-weight-medium mr-auto">
        {{ $t("acceptance.weighings.title") }}
      </div>
      <v-btn
        color="primary"
        variant="outlined"
        :disabled="disabled"
        @click="$emit('add')"
      >
        {{ $t("acceptance.weighings.add") }}
      </v-btn>
    </div>

    <!-- Append-only: rows have no edit or delete action. -->
    <div v-if="!rows.length" class="acceptance-weighings-empty text-body-2">
      {{ $t("acceptance.weighings.empty") }}
    </div>
    <div v-else class="acceptance-weighings-table">
      <v-table density="comfortable">
        <thead>
          <tr>
            <th class="text-left">
              {{ $t("acceptance.weighings.weighed_at") }}
            </th>
            <th class="text-left">{{ $t("acceptance.weighings.method") }}</th>
            <th class="text-left">{{ $t("acceptance.weighings.gross") }}</th>
            <th class="text-left">{{ $t("acceptance.weighings.tare") }}</th>
            <th class="text-left">{{ $t("acceptance.weighings.net") }}</th>
            <th class="text-left">{{ $t("acceptance.weighings.proof") }}</th>
            <th class="text-left">
              {{ $t("acceptance.weighings.verified_by") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td class="text-no-wrap">{{ formatTime(row.weighedAt) }}</td>
            <td>
              {{ $t(`acceptance.weighings.methods_short.${row.method}`) }}
            </td>
            <td class="text-no-wrap">{{ formatKg(row.gross) }}</td>
            <td class="text-no-wrap">{{ formatKg(row.tare) }}</td>
            <td class="text-no-wrap">
              <span :class="{ 'font-weight-bold': row.id === currentId }">
                {{ formatKg(row.net) }}
              </span>
              <v-chip
                v-if="row.id === currentId"
                size="x-small"
                color="green"
                variant="tonal"
                class="ml-2"
              >
                {{ $t("acceptance.weighings.current") }}
              </v-chip>
            </td>
            <td>{{ proof(row) }}</td>
            <td>{{ (row.verifiedBy && row.verifiedBy.name) || "—" }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import { sortWeighings } from "@/components/Acceptance/weighingForm.mjs";

export default {
  name: "AcceptanceWeighingsCard",
  props: {
    weighings: { type: Array, default: () => [] },
    // dossier.currentWeighingId: the API decides which weighing is current.
    currentId: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["add"],
  computed: {
    rows() {
      return sortWeighings(this.weighings);
    },
  },
  methods: {
    formatTime(value) {
      return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
    },
    formatKg(value) {
      if (value === null || value === undefined) return "—";
      const number = new Intl.NumberFormat(this.$i18n.locale, {
        maximumFractionDigits: 1,
      }).format(value);
      return `${number} kg`;
    },
    proof(row) {
      if (row.method === "gross_tare") {
        return this.$t("acceptance.weighings.ticket_proof", {
          number: row.ticketNumber || "—",
        });
      }
      return row.device || "—";
    },
  },
};
</script>

<style scoped>
.acceptance-weighings-empty {
  padding: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.acceptance-weighings-table {
  overflow-x: auto;
}
</style>
